import request from '@/utils/request'

/**
 * 获取特殊活动信息
 * @param {string} id - 活动ID
 * @returns {Promise} 返回活动详情数据
 */
export function getSpecialActivity(id) {
  return request({
    url: '/api/Activity/GetSpecialActivity',
    method: 'post',
    data: {
      Id: id
    }
  }).then(response => {
    // 处理响应数据
    if (response.ErrorCode === 0 && response.Data) {
      return response.Data
    } else {
      // 当返回数据为空或者错误时抛出异常
      throw new Error(response.ErrorMessage || '获取活动数据失败')
    }
  }).catch(error => {
    // 统一错误处理
    console.error('获取特殊活动数据失败:', error)
    throw error
  })
}

/**
 * 解析导航配置
 * @param {string} navigationConfig - JSON字符串格式的导航配置
 * @returns {Array} 解析后的导航配置数组
 */
export function parseNavigationConfig(navigationConfig) {
  try {
    return JSON.parse(navigationConfig || '[]')
  } catch (error) {
    console.error('解析导航配置失败:', error)
    return []
  }
} 